import { FiChevronRight, FiHome } from "react-icons/fi";

const BreadcrumbItem = ({ menu, link, top = false, handleNavigate = null }) => {
  let current = false;
  if (!link && !handleNavigate) {
    current = true;
  }
  return (
    <li>
      <div className="flex items-center whitespace-nowrap lg:text-base text-[14px]">
        {menu === "TOP" && <FiHome className="mr-[12px] text-[#667085]" size={20} />}
        {top === false && <FiChevronRight className="mr-[12px]" size={20} />}
        {current ? (
          <span className="whitespace-nowrap">{menu}</span>
        ) : handleNavigate ? (
          <button className="text-[#2e90fa] hover:text-[#2374fd] whitespace-nowrap bg-transparent border-none cursor-pointer" onClick={handleNavigate}>
            {menu}
          </button>
        ) : (
          <a href={link} className="text-[#2e90fa] hover:text-[#2374fd] whitespace-nowrap">
            {menu}
          </a>
        )}
      </div>
    </li>
  );
};

export default BreadcrumbItem;
